import { type Step } from '@wix/ambassador-forms-v4-form/types';

export const getStepIndex = (stepId?: string, steps?: Step[]) => {
  if (stepId) {
    const stepIndex = steps?.findIndex((step) => step.id === stepId);

    if (stepIndex !== undefined && stepIndex !== -1) {
      return stepIndex;
    }
  }

  return 0;
};
